<script>
    import app from "../stores/app";
    import R, {LOADER} from "../lib/requests";
    import {formatDate} from "../lib/lib";
    import Modal from '../components/modal/Modal.svelte';
    import AppIcon from "../components/icons/AppIcon.svelte";

    export let transferId = 0;
    export let transferDate = null;
    export let vehicleTypeId = null;
    export let vehicle = null;
    export let driver = null;
    export let transporterId = 0;
    export let disableType = false;
    export let closeCallback;

    let transporters = [];
    let list = [];
    let licenceNo = '';
    let driverName = '';
    let vehicleId = null;
    let driverId = null;
    let initialized = false;

    const initialize = () => {
        transferDate = formatDate(transferDate, 'y-m-d');
        vehicleId = vehicle ? vehicle.id : 0;
        driverId = driver ? driver.id : 0;

        loadTransporters();
        load();
    }

    const loadTransporters = () => {
        const onSuccess = result => {
            transporters = [{id: 0, name: 'transporter'}, ...result];
        };

        const onFailure = err => {
        };

        R.handle(R.transporter.index, {is_active: 1}, onSuccess, onFailure, LOADER.POPUP);
    }

    const load = () => {

        const onSuccess = result => {
            list = result;
            list.map(item => {
                item.total_transfers = 0;
                item.drivers.map(driver => {
                    item.total_transfers += driver.transfers.length;
                });
                item.total_transfers = item.total_transfers || '';
            });
            initialized = true;
        };

        const onFailure = err => {
            initialized = true;
        };

        let data = {
            vehicle_type_id: vehicleTypeId,
            transporter_id: transporterId,
            licence_no: licenceNo,
            driver_name: driverName,
            is_active: 1,
            transfer_id: transferId,
            transfer_at: transferDate,
        }

        R.handle(R.vehicle.search, data, onSuccess, onFailure, LOADER.POPUP);
    };

    const onDriverClick = (vehicle, driver) => {

        close({vehicle, driver});
    }

    const close = (param) => {
        if (param instanceof Event) {
            closeCallback();
            return;
        }

        setTimeout(() => {
            closeCallback(param);
        }, 100);
    }

    initialize();
</script>

{#if initialized}
    <Modal modalMd title="Select Vehicle and Driver" on:close="{ close }">
        <div slot="body">
            <div class="tools-box">
                <div class="container">
                    <select class="form-select me-lg-1" bind:value="{ vehicleTypeId }" on:change="{ load }"
                            disabled="{disableType}">
                        <option value="0">vehicle type</option>
                        {#each $app.vehicle_types as item}
                            <option value="{ item.id }">{ item.name }</option>
                        {/each}
                    </select>
                    <select class="form-select me-lg-1" bind:value="{ transporterId }" on:change="{ load }">
                        {#each transporters as item}
                            <option value="{ item.id }">{ item.name }</option>
                        {/each}
                    </select>
                </div>
                <div class="container">
                    <input type="text" class="form-control me-lg-1" bind:value="{ licenceNo }" on:change="{ load }"
                           placeholder="licence no">
                    <input type="text" class="form-control me-lg-1" bind:value="{ driverName }" on:change="{ load }"
                           placeholder="driver name">
                    <button class="btn btn-primary" type="button">
                        <AppIcon icon="search"/>
                    </button>
                </div>
            </div>
            <hr>

            <table class="table table-list">
                <tbody>
                {#each list as vehicle}
                    <tr class="row-hover pointer" class:row-selected="{ vehicleId == vehicle.id }">
                        <td on:click="{ () => vehicleId = vehicle.id }">
                            {#if transporterId == 0}
                                <div class="small">{ vehicle.transporter_name }</div>
                            {/if}
                            { vehicle.licence_no }
                        </td>
                        <td class="vehicle_transfers text-gray">
                            <span title="total transfers for { formatDate(transferDate, 'd-m-y') }">{ vehicle.total_transfers }</span>
                        </td>
                    </tr>
                    {#if vehicleId == vehicle.id}
                        <tr>
                            <td class="container-column pt-0" colspan="2">
                                {#if vehicle.drivers.length}
                                    <table class="table table-list table-sm">
                                        <tbody>
                                        {#each vehicle.drivers as driver}
                                            <tr class:row-active={driverId == driver.id}>
                                                <td class="is-link" on:click="{ () => onDriverClick(vehicle, driver) }">
                                                    { driver.name }
                                                </td>
                                                <td class="driver_transfers">
                                                    {#if driver.transfers.length}
                                                        <a href="/app/transfers?date={ transferDate }&driver_id={ driver.id }"
                                                           class="is-link"
                                                           title="open driver transfers on new tab"
                                                           target="_blank">{ driver.transfers.length }</a>
                                                    {/if}
                                                </td>
                                            </tr>
                                        {/each}
                                        </tbody>
                                    </table>
                                {:else}
                                    <div class="text-danger mt-2">
                                        Could not find drivers assigned to this vehicle!<br>
                                        Goto transporter and assign one or more drivers to this vehicle.
                                    </div>
                                {/if}
                            </td>
                        </tr>
                    {/if}
                {/each}
                </tbody>
            </table>
            <hr>
            <div class="text-end">
                <div class="btn btn-link" on:click="{ () => close() }">Close</div>
            </div>
        </div>
    </Modal>
{/if}

<style>
    .vehicle_transfers {
        width: 65px;
        text-align: center;
    }

    .driver_transfers {
        width: 50px;
        text-align: center;
    }
</style>
